import { render } from "./LanguageModal.vue?vue&type=template&id=50e3600c"
import script from "./LanguageModal.vue?vue&type=script&lang=js"
export * from "./LanguageModal.vue?vue&type=script&lang=js"
script.render = render

export default script